/**
 * SpaceThreadSelector — Two-row layout for entrepreneur tier.
 * Row 1: Space tabs (icon + name, colored underline for active)
 * Row 2: ThreadSelector with threads filtered to active space
 */

import ThreadSelector from './ThreadSelector';

export default function SpaceThreadSelector({
  spaces,
  threads,
  activeSpaceId,
  activeThreadId,
  onSelectSpace,
  onSelectThread,
  onThreadsChange,
  onDeleteThread,
  onClearThread
}) {
  // Filter threads to active space
  const spaceThreads = threads.filter(t => t.space_id === activeSpaceId);

  return (
    <div>
      {/* Row 1: Space tabs */}
      <div className="border-b border-slate-800 px-safe-4 py-1.5 flex items-center gap-1 overflow-x-auto no-scrollbar scroll-fade-r">
        {spaces.map(space => (
          <button
            key={space.id}
            onClick={() => onSelectSpace(space.id)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs whitespace-nowrap transition-colors ${
              space.id === activeSpaceId
                ? 'bg-slate-700/50 text-slate-200 border-b-2 border-blue-400'
                : 'text-slate-500 hover:text-slate-300 hover:bg-slate-800/50'
            }`}
          >
            {space.icon && <span>{space.icon}</span>}
            {space.name}
          </button>
        ))}
      </div>

      {/* Row 2: Thread tabs for active space */}
      <ThreadSelector
        threads={spaceThreads}
        activeThreadId={activeThreadId}
        onSelectThread={onSelectThread}
        onThreadsChange={onThreadsChange}
        onDeleteThread={onDeleteThread}
        onClearThread={onClearThread}
        spaceId={activeSpaceId}
      />
    </div>
  );
}
